var _style, _g, _g2, _g3, _g4, _g5, _g6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShieldLeft(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275.6 491.1",
    style: {
      enableBackground: "new 0 0 275.6 491.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#89898A;}\n\t.st1{fill:#2F2F2F;}\n\t.st2{fill:#848584;}\n\t.st3{fill:#FFD500;stroke:#000000;stroke-miterlimit:10;}\n\t.st4{fill:#A1A1A1;stroke:#000000;stroke-miterlimit:10;}\n\t.st5{fill:#DFDFDF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.8,15.9h27.8v43.6c-9.3-1.5-18.5-2.7-27.8-3.2V15.9L235.8,15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.6,59.5V164c-9.6-1.6-19.1-3-27.8-7.1V56.3C245,56.8,254.3,58,263.6,59.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.6,164v327.1h-27.8V156.8C244.5,160.9,254,162.4,263.6,164z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M46.3,139.9h220c2.9,0,5.3-2.4,5.3-5.3V49c0-2.9-2.4-5.3-5.3-5.3h-220c-1.6,0-3,0.7-4,1.9L6.2,89.1 c-1.6,2-1.6,4.8,0,6.8l36.1,42.2C43.3,139.3,44.8,139.9,46.3,139.9L46.3,139.9z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 243.2,
    cy: 66.8,
    r: 6.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 243.2,
    cy: 121,
    r: 6.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M266.8,18.6h-33.4V1.3c0-0.7,0.6-1.3,1.3-1.3h30.9c0.7,0,1.3,0.6,1.3,1.3L266.8,18.6L266.8,18.6L266.8,18.6z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "d"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldLeft);
export default __webpack_public_path__ + "static/media/shield-left.4b3990214fbc1586b9bc1f0a101ce459.svg";
export { ForwardRef as ReactComponent };